import Navigator from 'app';
import BillAuthorModel from './bill_author_model';
import BillAuthorCollection from './bill_author_collection';
import BillStatusListingCollection from './bill_status_listing_collection';
import BillVersionCollection from './bill_version_collection';
import BillVoteCollection from './bill_vote_collection';
import BillPredictionCollection from './bill_prediction_collection';
const BillDetailModel = Backbone.Model.extend({
  initialize: function initialize(param) {
    this.url = Navigator.config.api_base + "bills/" + param;
  },
  parse: function parse(response) {
    const data = response;
    if (response.author) {
      data.author = new BillAuthorModel(response.author);
    }
    if (response.coauthors) {
      data.coauthors = new BillAuthorCollection(response.coauthors);
    }
    if (response.bill_status_listings) {
      data.bill_status_listings = new BillStatusListingCollection(response.bill_status_listings);
    }
    if (response.versions) {
      data.versions = new BillVersionCollection(response.versions);
      const latest = data.versions.where({
        id: data.latest_version_id
      })[0];
      if (typeof latest === 'undefined') {
        data.latest_version_distance = 0;
      } else {
        data.latest_version_distance = latest.get("distance");
      }
    }
    if (response.votes) {
      data.votes = new BillVoteCollection(response.votes);
    }
    if (response.predictions_history) {
      data.predictions_history = new BillPredictionCollection(response.predictions_history);
    }
    return data;
  }
});
const API = {
  getBillDetail: function (param) {
    const d = $.Deferred();
    const bill = new BillDetailModel(param);
    console.log(bill.url);
    bill.fetch({
      dataType: "json",
      success: function (data) {
        d.resolve(data);
      },
      error: function (error) {
        d.reject('Could not fetch data for bill ' + param);
      }
    });
    return d.promise();
  }
};
Navigator.reqres.setHandler("bill:detail", function (param) {
  return API.getBillDetail(param);
});
export { BillDetailModel as default };